import { Alert, Heading, Paragraph } from "@digdir/designsystemet-react";
import { useQuery } from "@tanstack/react-query";
import { useParams } from "@tanstack/react-router";
import { useTranslation } from "react-i18next";
import { httpClient } from "@/api/client";
import { getAvtalePrivatOptions } from "@/api/generated/@tanstack/react-query.gen";
import { Page } from "@/components";
import { formatDateString } from "@/utils";
import { EndreAvtaleFormSkeleton } from "./components/endre/EndreAvtaleFormSkeleton";
import { EndrePrivatAvtaleForm } from "./components/endre/EndrePrivatAvtaleForm";
export const EndrePrivatAvtalePage = () => {
  const { t } = useTranslation();
  const params = useParams({
    from: "/_app/avtaler/$avtalerId/privat/endre/",
  });

  const {
    data: privatAvtale,
    isLoading: isLoadingPrivatAvtale,
    isError: isErrorPrivatAvtale,
  } = useQuery({
    ...getAvtalePrivatOptions({
      client: httpClient,
      path: {
        id: params.avtalerId,
      },
    }),
  });

  return (
    <Page withBackLink>
      <Heading>{t("pages.endre.tittel")}</Heading>
      <Paragraph>
        {t("pages.endre.beskrivesle", {
          context: formatDateString(privatAvtale?.avtale.avbestillingsFrist),
        })}
      </Paragraph>
      {isLoadingPrivatAvtale ? (
        <EndreAvtaleFormSkeleton />
      ) : isErrorPrivatAvtale === true || privatAvtale?.avtale == null ? (
        <Alert data-color={"danger"}>
          {t("pages.endre.form.feil.feil-lasting")}
        </Alert>
      ) : privatAvtale.avtale.avtaleStatus !== "Aktiv" ? (
        <div className="flex flex-col my-8">
          <Alert>
            {t("pages.avtaler.statuser.avtaleStatus", {
              context: privatAvtale.avtale.avtaleStatus,
            })}
          </Alert>
        </div>
      ) : (
        <EndrePrivatAvtaleForm avtale={privatAvtale} />
      )}
    </Page>
  );
};
